import { Box, Grid, Modal, Stack, styled } from '@mui/material';
import { sendTalkToSalesEmail } from 'wisestep-api';
import {
  Item,
  IUserDTO,
  Label,
  WsButton,
  WsColors,
  WsTypography,
  WsTypoVariants,
} from 'wisestep-base';

import { useUserContext } from '../../context';
import { warning, success } from '../../utils/NotificationMessages';
import { useNotificationStore } from '../../utils/NotificationStore';
import { openUrlInNewTab } from '../../utils/openUrlInNewTab';

import Checkmark from './check.png';
import { useSKUModalStore } from './SKUModalStore';

const ModalBox = styled(Box)({
  position: 'absolute' as const,
  top: '20%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
});
const SKUModal = () => {
  const loggedInUser = useUserContext().userDTO as IUserDTO;
  const skuStore = useSKUModalStore((state) => state);
  const skuResponse = useSKUModalStore((state) => state.skuModal);
  const setNotification = useNotificationStore((state) => state.setNotification);
  const notify = useSKUModalStore((state) => state.notify);
  const view = useSKUModalStore((state) => state.view);

  const sendEmailToSales = async () => {
    try {
      const response = await sendTalkToSalesEmail();
      console.log('response', response);
      if (response.status === 200) {
        console.log('response');
        setNotification(success('Request Processed Successfully'));
        skuStore.closeModal();
      }
    } catch (error) {
      setNotification(warning('Something Went Wrong , Please try again'));
    }
  };

  return (
    <Modal open={notify} onClose={skuStore.closeModal}>
      <ModalBox borderRadius={1.5} bgcolor={WsColors.TertiaryShades100} p={2} width={816}>
        {view === 0 &&
          (skuResponse.type === 'count' ? (
            <Grid justifyContent="center" container>
              <Grid item>
                <Stack direction="column">
                  <Item>
                    <WsTypography variant={WsTypoVariants.TITLE}>
                      You have exhausted your current quota, To upgrade your Subscription, Talk to
                      your Wisestep Sales or Customer Success Rep.
                    </WsTypography>
                  </Item>
                  <Item>
                    <Label sx={{ fontWeight: 'bold' }}>
                      Available Quota: {skuResponse.object?.balance} out of{' '}
                      {skuResponse.object?.actualLimit} available
                    </Label>
                  </Item>
                  <Item>
                    <Label>{skuResponse.object?.message}</Label>
                  </Item>
                  <WsButton size="large" variant="contained" onClick={() => skuStore.setView(1)}>
                    Talk to Wisestep Team
                  </WsButton>
                </Stack>
              </Grid>
            </Grid>
          ) : (
            <Grid justifyContent="center" container>
              <Grid item>
                <Stack direction="column">
                  <Item>
                    <WsTypography variant={WsTypoVariants.TITLE}>
                      Upgrade your Subscription, Talk to your Wisestep Sales or Customer Success Rep
                      Your current subscription does not include the feature you have accessed.
                    </WsTypography>
                  </Item>
                  <Item>
                    <WsButton size="large" variant="contained" onClick={() => skuStore.setView(1)}>
                      Talk to Wisestep Team
                    </WsButton>
                  </Item>
                </Stack>
              </Grid>
            </Grid>
          ))}
        {view === 1 && (
          <Grid justifyContent="center" container>
            <Grid item justifyContent="center" direction="row">
              <Stack direction="column" alignItems="center" justifyContent="space-between">
                <img src={Checkmark} alt="CareerBuilder" width="50" height="50" />
              </Stack>

              <Item>
                <Label>
                  We will contact you Shortly . Please confirm your contact details{'  '}
                  {loggedInUser.phoneNumber}
                </Label>
              </Item>
            </Grid>
            <Grid item>
              <Stack justifyContent="center" direction="row">
                <Item>
                  <WsButton
                    size="large"
                    variant="outlined"
                    onClick={() => openUrlInNewTab('/recruiter/profile')}
                  >
                    Change
                  </WsButton>
                </Item>
                <Item>
                  <WsButton size="large" variant="contained" onClick={() => sendEmailToSales()}>
                    Confirm
                  </WsButton>
                </Item>
              </Stack>
            </Grid>
          </Grid>
        )}
      </ModalBox>
    </Modal>
  );
};
export default SKUModal;
